"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioCard = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = __importStar(require("react"));
const radio_card_group_types_1 = require("./radio-card-group.types");
const radio_card_styles_1 = require("./radio-card.styles");
const Lock = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/lock'))));
const numberWithSpaces = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
const RadioCard = ({ label, id, name, value, description, message, checked, disabled, error, onChange, icon, textAlign, currency, isBasicVersion, testId = 'radiocard', }) => {
    const isCurrency = currency ? true : false;
    return (react_1.default.createElement(radio_card_styles_1.StyledRadioCardWrapper, null,
        react_1.default.createElement(radio_card_styles_1.StyledRadioInput, { id: id, name: name, value: value, checked: checked, disabled: disabled, onChange: onChange, isHidden: isCurrency, isCurrency: isCurrency, isBasicVersion: isBasicVersion, "data-testid": testId }),
        react_1.default.createElement(radio_card_styles_1.StyledRadioCardContent, { icon: icon, error: error, disabled: disabled, isCurrency: isCurrency, isBasicVersion: isBasicVersion, checked: checked },
            !isBasicVersion && disabled && (react_1.default.createElement(radio_card_styles_1.StyledLockIconWrapper, { hasIcon: !!icon },
                react_1.default.createElement(react_1.Suspense, { fallback: null },
                    react_1.default.createElement(Lock, { width: 22, color: theme_1.colors.textDisabled })))),
            react_1.default.createElement(radio_card_styles_1.StyledRadioCardLabel, { textAlign: textAlign, disabled: disabled, isCurrency: isCurrency, isBasicVersion: isBasicVersion }, isCurrency
                ? `${numberWithSpaces(label)} ${currency ? radio_card_group_types_1.CurrencyType[currency] : '$'}`
                : label),
            description && (react_1.default.createElement(radio_card_styles_1.StyledRadioCardDescription, { isBasicVersion: isBasicVersion, error: error }, description)),
            icon && react_1.default.createElement(radio_card_styles_1.StyledIcon, null, icon),
            message && react_1.default.createElement(radio_card_styles_1.StyledRadioCardMessage, null, message))));
};
exports.RadioCard = RadioCard;
